import {SettlementStatus, settlementStatuses} from "@ots-frontend/ots-data";
import {BaseDbCodeSelect, DbCodeSelectProps} from "../base-db-code-select";

type Props = DbCodeSelectProps<SettlementStatus>;

export const SettlementStatusSelect = (props: Props) => {
  const {options = settlementStatuses, ...rest} = props;
  return <BaseDbCodeSelect options={options} {...rest} />;
};
